// import React, { useEffect, useMemo, useRef, useState } from "react";
// import styles from "./Attendance.module.css";
// import { useAuth } from "../../components/context/Auth";
// import HrmFilters from "../../components/updatedComponents/hrm/HrmFillters";
// import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
// import StaffDetailModal from "./StaffDetailModal";
// import {
//   STATUS_OPTIONS,
//   STATUS_COLORS,
//   TODAY,
//   EMPLOYEES,
//   buildInitialRecords,
//   updateRecordStatus,
//   updateEmployeeSalary,
//   formatDate,
//   AllDesignation,
// } from "./HrmData";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

// const SortAscIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M11 5v14" />
//     <path d="M5 11l6-6 6 6" />
//   </svg>
// );

// const SortDescIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M11 19V5" />
//     <path d="M5 13l6 6 6-6" />
//   </svg>
// );

// const Attendance = () => {
//   const { mode } = useAuth();
//   const [role, setRole] = useState([]);
//   useEffect(() => {
//     if (AllDesignation) {
//       setRole(
//         AllDesignation.map((r) => ({
//           label: r.name,
//           value: r.name,
//         })),
//       );
//     }
//   }, []);
//   const [employees, setEmployees] = useState(EMPLOYEES); // holds salary edits made in StaffDetailModal
//   const [records, setRecords] = useState(buildInitialRecords); // holds attendance edits made in StaffDetailModal
//   const [history, setHistory] = useState([]); // audit log of edits, shown in StaffDetailModal's History tab
//   const [keyword, setKeyword] = useState("");
//   const [selectedFilter, setSelectedFilter] = useState("All");
//   const [selectedDate, setSelectedDate] = useState(TODAY);
//   const [sortOrder, setSortOrder] = useState("asc");
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [viewRecord, setViewRecord] = useState(null);
//   const [detailEmployeeId, setDetailEmployeeId] = useState(null); // id shown in StaffDetailModal
//   const menuRef = useRef(null);

//   const employeeMap = useMemo(
//     () => Object.fromEntries(employees.map((e) => [e.id, e])),
//     [employees],
//   );
//   const detailEmployee =
//     detailEmployeeId != null ? employeeMap[detailEmployeeId] : null;

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (menuRef.current && !menuRef.current.contains(e.target)) {
//         setOpenMenuId(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const recordsForSelectedDate = useMemo(() => {
//     return records
//       .filter((r) => r.date === selectedDate)
//       .map((r) => ({ ...r, employee: employeeMap[r.employeeId] }))
//       .filter((r) => r.employee);
//   }, [records, selectedDate, employeeMap]);

//   const statusCards = useMemo(() => {
//     const counts = { All: recordsForSelectedDate.length };
//     STATUS_OPTIONS.forEach((s) => (counts[s] = 0));
//     recordsForSelectedDate.forEach((r) => {
//       counts[r.status] = (counts[r.status] || 0) + 1;
//     });

//     return [
//       { status: "All", count: counts.All, subtitle: "All employees" },
//       { status: "Present", count: counts.Present, subtitle: "Marked present" },
//       { status: "Absent", count: counts.Absent, subtitle: "Marked absent" },
//       {
//         status: "Half-Day",
//         count: counts["Half-Day"],
//         subtitle: "Half day rows",
//       },
//       { status: "Leave", count: counts["Leave"], subtitle: "Marked Leave" },
//     ];
//   }, [recordsForSelectedDate]);

//   const getRowStyle = () => ({ background: mode ? "#1B1D21" : "#FFFFFF" });

//   const filteredRecords = useMemo(() => {
//     const result = recordsForSelectedDate.filter((r) => {
//       const search =
//         r.employee.name.toLowerCase().includes(keyword.toLowerCase()) ||
//         r.employee.department.toLowerCase().includes(keyword.toLowerCase()) ||
//         r.employee.staffId.toLowerCase().includes(keyword.toLowerCase());

//       const filter =
//         selectedFilter === "All" ? true : r.status === selectedFilter;
//       return search && filter;
//     });

//     result.sort((a, b) => {
//       const diff = a.employee.name.localeCompare(b.employee.name);
//       return sortOrder === "asc" ? diff : -diff;
//     });

//     return result;
//   }, [recordsForSelectedDate, keyword, selectedFilter, sortOrder]);

//   const handleStatusChange = (recordId, newStatus) => {
//     setRecords((prev) =>
//       prev.map((r) => (r.id === recordId ? { ...r, status: newStatus } : r)),
//     );
//   };

//   const handleDelete = (recordId) => {
//     setRecords((prev) => prev.filter((r) => r.id !== recordId));
//     setOpenMenuId(null);
//   };

//   const handleView = (record) => {
//     setViewRecord(record);
//     setOpenMenuId(null);
//   };

//   // Opens the single-staff detail modal (Attendance calendar + Salary Slip).
//   // Ignores clicks that started on the status buttons or the action menu,
//   // since those already have their own click behavior.
//   const handleRowClick = (e, record) => {
//     if (
//       e.target.closest(`.${styles.statusButtons}`) ||
//       e.target.closest(`.${styles.actionCell}`)
//     ) {
//       return;
//     }
//     setDetailEmployeeId(record.employee.id);
//   };

//   // Called from inside StaffDetailModal when a calendar day is edited.
//   const handleUpdateStatus = (employeeId, date, status) => {
//     setRecords((prev) => updateRecordStatus(prev, employeeId, date, status));
//     setHistory((prev) => [
//       ...prev,
//       {
//         id: `${employeeId}-${date}-${Date.now()}`,
//         employeeId,
//         timestamp: new Date().toISOString(),
//         type: "attendance",
//         description: status
//           ? `Marked ${formatDate(date)} as ${status}`
//           : `Cleared attendance for ${formatDate(date)}`,
//       },
//     ]);
//   };

//   // Called from inside StaffDetailModal when gross salary is edited.
//   const handleUpdateSalary = (employeeId, monthlySalary) => {
//     setEmployees((prev) =>
//       updateEmployeeSalary(prev, employeeId, monthlySalary),
//     );
//     setHistory((prev) => [
//       ...prev,
//       {
//         id: `${employeeId}-salary-${Date.now()}`,
//         employeeId,
//         timestamp: new Date().toISOString(),
//         type: "salary",
//         description: `Gross salary updated to ₹${monthlySalary.toLocaleString("en-IN")}`,
//       },
//     ]);
//   };

//   const gridColumns = "0.5fr 1fr 1.4fr 1.2fr 1.5fr 1.8fr";

//   return (
//     <div
//       className={styles.attendance}
//       style={mode ? { background: "#2C2E33", border: "none" } : {}}
//     >
//       <div className={styles.attendance_body}>
//         <div
//           className={styles.attendance_filters_wrapper}
//           style={mode ? { background: "#232529" } : {}}
//         >
//           <HrmFilters
//             mode={mode}
//             headerData={statusCards}
//             selectedFilter={selectedFilter}
//             handleClick={setSelectedFilter}
//             type="attendance"
//           />
//         </div>
//       </div>

//       <div className={styles.attendance_data}>
//         <div className={styles.attendance_data_filters}>
//           <SearchBar
//             placeholder="Search Employee..."
//             value={keyword}
//             padding="5px 10px"
//             onChange={(e) => setKeyword(e.target.value)}
//             onClear={() => setKeyword("")}
//           />

//           <div>
//             {selectedDate !== TODAY && (
//               <button
//                 type="button"
//                 className={styles.clearDateBtn}
//                 onClick={() => setSelectedDate(TODAY)}
//               >
//                 Back to today
//               </button>
//             )}

//             <div className={styles.period}>
//               <InputTypedate
//                 text={"Date"}
//                 value={selectedDate}
//                 onChange={(e) => setSelectedDate(e.target.value)}
//               />
//             </div>

//             <button
//               type="button"
//               className={styles.sortOrderBtn}
//               onClick={() =>
//                 setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
//               }
//               title={
//                 sortOrder === "asc"
//                   ? "Sorted A to Z — click for Z to A"
//                   : "Sorted Z to A — click for A to Z"
//               }
//             >
//               {sortOrder === "asc" ? <SortAscIcon /> : <SortDescIcon />}
//               <span>{sortOrder === "asc" ? "Ascending" : "Descending"}</span>
//             </button>

//             <DropDown
//               label={"Designation"}
//               listLabel={"All"}
//               options={role}
//               onSelect={(option) => setRole(option.value)}
//               onReject={() => setRole(null)}
//             />
//           </div>
//         </div>

//         <ul className={styles.attendanceTable}>
//           <li
//             className={styles.attendanceTableHeader}
//             style={{
//               gridTemplateColumns: gridColumns,
//               background: mode ? "#232529" : "#d9dce5",
//               color: mode ? "#fff" : "#646b88",
//             }}
//           >
//             <div>S.No.</div>
//             <div>Staff Id</div>
//             <div>Staff</div>
//             <div>Designation</div>
//             <div>Shift</div>
//             {/* <div>Date</div> */}
//             <div>Status</div>
//             {/* <div>Action</div> */}
//           </li>

//           {filteredRecords.length === 0 && (
//             <li className={styles.attendanceEmptyRow}>
//               No attendance found for {formatDate(selectedDate)}.
//             </li>
//           )}

//           {filteredRecords.map((record, index) => (
//             <li
//               key={record.id}
//               className={`${styles.attendanceTableRow} ${mode ? styles.attendanceTableRowDark : ""}`}
//               style={{ gridTemplateColumns: gridColumns, ...getRowStyle() }}
//               onClick={(e) => handleRowClick(e, record)}
//               title="Click to view staff attendance & salary slip"
//             >
//               <div>{index + 1}</div>
//               <div>{record.employee.staffId}</div>
//               <div>{record.employee.name}</div>
//               <div>{record.employee.department}</div>
//               <div>{record.employee.shift}</div>
//               {/* <div>{formatDate(record.date)}</div> */}

//               <div className={styles.statusButtons}>
//                 {STATUS_OPTIONS.map((option) => {
//                   const color = STATUS_COLORS[option];
//                   const isActive = record.status === option;
//                   return (
//                     <button
//                       key={option}
//                       type="button"
//                       onClick={() => handleStatusChange(record.id, option)}
//                       className={styles.statusButton}
//                       style={{
//                         borderColor: isActive
//                           ? color.border
//                           : mode
//                             ? "#ffffff"
//                             : "#000000",
//                         background: isActive ? color.border : "transparent",
//                         color: isActive
//                           ? "#ffffff"
//                           : mode
//                             ? "#ffffff"
//                             : "#000000",
//                       }}
//                     >
//                       {option}
//                     </button>
//                   );
//                 })}
//               </div>

//               {/* <div className={styles.actionCell}>
//                 <button
//                   type="button"
//                   className={styles.actionDotsBtn}
//                   onClick={() =>
//                     setOpenMenuId(openMenuId === record.id ? null : record.id)
//                   }
//                   aria-label="Row actions"
//                 >
//                   &#8942;
//                 </button>

//                 {openMenuId === record.id && (
//                   <div
//                     ref={menuRef}
//                     className={`${styles.actionDropdown} ${mode ? styles.actionDropdownDark : ""}`}
//                   >
//                     <button
//                       type="button"
//                       className={styles.actionDropdownItem}
//                       onClick={() => handleView(record)}
//                     >
//                       <span className={styles.actionDropdownIcon}>
//                         <EyeIcon />
//                       </span>
//                       <span>View</span>
//                     </button>
//                     <button
//                       type="button"
//                       className={`${styles.actionDropdownItem} ${styles.actionDropdownItemDanger}`}
//                       onClick={() => handleDelete(record.id)}
//                     >
//                       <span className={styles.actionDropdownIcon}>
//                         <TrashIcon />
//                       </span>
//                       <span>Delete</span>
//                     </button>
//                   </div>
//                 )}
//               </div> */}
//             </li>
//           ))}
//         </ul>
//       </div>

//       {viewRecord && (
//         <div
//           className={styles.modalOverlay}
//           onClick={() => setViewRecord(null)}
//         >
//           <div
//             className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className={styles.modalCloseBtn}
//               onClick={() => setViewRecord(null)}
//             >
//               &times;
//             </button>
//             <h3>{viewRecord.employee.name}</h3>
//             <p>
//               <strong>Staff ID:</strong> {viewRecord.employee.staffId}
//             </p>
//             <p>
//               <strong>Designation:</strong> {viewRecord.employee.department}
//             </p>
//             <p>
//               <strong>Shift:</strong> {viewRecord.employee.shift}
//             </p>
//             <p>
//               <strong>Date:</strong> {formatDate(viewRecord.date)}
//             </p>
//             <p>
//               <strong>Status:</strong>{" "}
//               <span
//                 style={{
//                   color: STATUS_COLORS[viewRecord.status]?.border,
//                   fontWeight: 600,
//                 }}
//               >
//                 {viewRecord.status}
//               </span>
//             </p>
//           </div>
//         </div>
//       )}

//       {/* Single-staff Attendance calendar + Salary Slip, opened by clicking a row.
//           Both the calendar days and the gross salary field are editable here. */}
//       {detailEmployee && (
//         <StaffDetailModal
//           employee={detailEmployee}
//           records={records}
//           history={history}
//           mode={mode}
//           onClose={() => setDetailEmployeeId(null)}
//           onUpdateStatus={handleUpdateStatus}
//           onUpdateSalary={handleUpdateSalary}
//         />
//       )}
//     </div>
//   );
// };

// export default Attendance;

// ---------------------------------- for add leaves typeslike paid leave sick leave and unpaid leave -------------------------

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { createPortal } from "react-dom";
// import styles from "./Attendance.module.css";
// import { useAuth } from "../../components/context/Auth";
// import HrmFilters from "../../components/updatedComponents/hrm/HrmFillters";
// import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
// import StaffDetailModal from "./StaffDetailModal";
// import {
//   STATUS_OPTIONS,
//   STATUS_COLORS,
//   TODAY,
//   EMPLOYEES,
//   buildInitialRecords,
//   updateRecordStatus,
//   updateEmployeeSalary,
//   formatDate,
//   AllDesignation,
// } from "./HrmData";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

// const SortAscIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M11 5v14" />
//     <path d="M5 11l6-6 6 6" />
//   </svg>
// );

// const SortDescIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M11 19V5" />
//     <path d="M5 13l6 6 6-6" />
//   </svg>
// );

// // Small chevron used to open the "pick a leave type" dropdown on a row
// const ChevronDownIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M6 9l6 6 6-6" />
//   </svg>
// );

// const PlusIcon = () => (
//   <svg
//     width="13"
//     height="13"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M12 5v14M5 12h14" />
//   </svg>
// );

// const TrashIcon = () => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M3 6h18" />
//     <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
//     <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
//     <path d="M10 11v6M14 11v6" />
//   </svg>
// );

// const DEFAULT_LEAVE_TYPES = [
//   "Paid Leave",
//   "Sick Leave",
//   "Casual Leave",
//   "Unpaid Leave",
// ];
// const LEAVE_TAG_COLOR = "#8B5CF6";

// const ROW_STATUS_OPTIONS = STATUS_OPTIONS.filter(
//   (option) => option !== "Leave",
// );

// // Width/height estimates used only to decide whether the portal-rendered
// // dropdown should open upward or downward, and to keep it inside the
// // viewport horizontally. Kept in one place so they're easy to tweak.
// const LEAVE_DROPDOWN_WIDTH = 200;
// const LEAVE_DROPDOWN_ITEM_HEIGHT = 36;
// const LEAVE_DROPDOWN_EXTRA_HEIGHT = 60; // divider + manage button + padding

// const Attendance = () => {
//   const { mode } = useAuth();
//   const [role, setRole] = useState([]);
//   useEffect(() => {
//     if (AllDesignation) {
//       setRole(
//         AllDesignation.map((r) => ({
//           label: r.name,
//           value: r.name,
//         })),
//       );
//     }
//   }, []);
//   const [employees, setEmployees] = useState(EMPLOYEES); // holds salary edits made in StaffDetailModal
//   const [records, setRecords] = useState(buildInitialRecords); // holds attendance edits made in StaffDetailModal
//   const [history, setHistory] = useState([]); // audit log of edits, shown in StaffDetailModal's History tab
//   const [keyword, setKeyword] = useState("");
//   const [selectedFilter, setSelectedFilter] = useState("All");
//   const [selectedDate, setSelectedDate] = useState(TODAY);
//   const [sortOrder, setSortOrder] = useState("asc");
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [viewRecord, setViewRecord] = useState(null);
//   const [detailEmployeeId, setDetailEmployeeId] = useState(null); // id shown in StaffDetailModal
//   const menuRef = useRef(null);
//   const tableRef = useRef(null); // scroll container for the attendance list

//   // --- Leave-type dropdown + manager state ---
//   const [leaveTypes, setLeaveTypes] = useState(DEFAULT_LEAVE_TYPES);
//   const [leaveMenuId, setLeaveMenuId] = useState(null); // record id whose leave dropdown is open
//   // Fixed viewport position for the portal-rendered leave dropdown.
//   // Computed from the trigger button's bounding rect so the dropdown is
//   // never clipped by the scrolling table container (see onClick below).
//   const [leaveMenuPos, setLeaveMenuPos] = useState(null); // {top, left}
//   const [showLeaveManager, setShowLeaveManager] = useState(false);
//   const [newLeaveTypeInput, setNewLeaveTypeInput] = useState("");

//   const employeeMap = useMemo(
//     () => Object.fromEntries(employees.map((e) => [e.id, e])),
//     [employees],
//   );
//   const detailEmployee =
//     detailEmployeeId != null ? employeeMap[detailEmployeeId] : null;

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (menuRef.current && !menuRef.current.contains(e.target)) {
//         setOpenMenuId(null);
//       }
//       // The leave dropdown now renders in a portal attached to
//       // document.body, so it's no longer a DOM descendant of the row.
//       // We close it based on whether the click landed on the trigger
//       // wrapper or on the portal dropdown itself.
//       if (
//         leaveMenuId !== null &&
//         !e.target.closest(`.${styles.leaveDropdownWrapper}`) &&
//         !e.target.closest(`.${styles.leaveDropdown}`)
//       ) {
//         setLeaveMenuId(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [leaveMenuId]);

//   // Close the leave dropdown if the table scrolls, so it doesn't end up
//   // floating in the wrong spot relative to the row that opened it.
//   useEffect(() => {
//     const tableEl = tableRef.current;
//     if (!tableEl) return;
//     const handleScroll = () => {
//       setLeaveMenuId(null);
//       setLeaveMenuPos(null);
//     };
//     tableEl.addEventListener("scroll", handleScroll);
//     return () => tableEl.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Also reposition/close on window resize to avoid a stale fixed position.
//   useEffect(() => {
//     if (leaveMenuId === null) return;
//     const handleResize = () => {
//       setLeaveMenuId(null);
//       setLeaveMenuPos(null);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [leaveMenuId]);

//   const recordsForSelectedDate = useMemo(() => {
//     return records
//       .filter((r) => r.date === selectedDate)
//       .map((r) => ({ ...r, employee: employeeMap[r.employeeId] }))
//       .filter((r) => r.employee);
//   }, [records, selectedDate, employeeMap]);

//   const statusCards = useMemo(() => {
//     const counts = { All: recordsForSelectedDate.length };
//     STATUS_OPTIONS.forEach((s) => (counts[s] = 0));
//     recordsForSelectedDate.forEach((r) => {
//       counts[r.status] = (counts[r.status] || 0) + 1;
//     });

//     return [
//       { status: "All", count: counts.All, subtitle: "All employees" },
//       { status: "Present", count: counts.Present, subtitle: "Marked present" },
//       { status: "Absent", count: counts.Absent, subtitle: "Marked absent" },
//       {
//         status: "Half-Day",
//         count: counts["Half-Day"],
//         subtitle: "Half day rows",
//       },
//       { status: "Leave", count: counts["Leave"], subtitle: "Marked Leave" },
//     ];
//   }, [recordsForSelectedDate]);

//   const getRowStyle = () => ({ background: mode ? "#1B1D21" : "#FFFFFF" });

//   const filteredRecords = useMemo(() => {
//     const result = recordsForSelectedDate.filter((r) => {
//       const search =
//         r.employee.name.toLowerCase().includes(keyword.toLowerCase()) ||
//         r.employee.department.toLowerCase().includes(keyword.toLowerCase()) ||
//         r.employee.staffId.toLowerCase().includes(keyword.toLowerCase());

//       const filter =
//         selectedFilter === "All" ? true : r.status === selectedFilter;
//       return search && filter;
//     });

//     result.sort((a, b) => {
//       const diff = a.employee.name.localeCompare(b.employee.name);
//       return sortOrder === "asc" ? diff : -diff;
//     });

//     return result;
//   }, [recordsForSelectedDate, keyword, selectedFilter, sortOrder]);

//   const handleStatusChange = (recordId, newStatus) => {
//     setRecords((prev) =>
//       prev.map((r) => (r.id === recordId ? { ...r, status: newStatus } : r)),
//     );
//   };

//   const handleDelete = (recordId) => {
//     setRecords((prev) => prev.filter((r) => r.id !== recordId));
//     setOpenMenuId(null);
//   };

//   const handleView = (record) => {
//     setViewRecord(record);
//     setOpenMenuId(null);
//   };

//   // Sets (or clears, if leaveType is null) the leave type on a row. Kept
//   // separate from `status` so a row can carry "Half-Day" + "Sick Leave"
//   // together if that's ever useful, without the two fields fighting.
//   const handleLeaveTypeChange = (recordId, leaveType) => {
//     setRecords((prev) =>
//       prev.map((r) => (r.id === recordId ? { ...r, leaveType } : r)),
//     );
//     setHistory((prev) => [
//       ...prev,
//       {
//         id: `${recordId}-leave-${Date.now()}`,
//         recordId,
//         timestamp: new Date().toISOString(),
//         type: "leave",
//         description: leaveType
//           ? `Marked leave type as ${leaveType}`
//           : "Cleared leave type",
//       },
//     ]);
//   };

//   const handleSelectLeaveType = (recordId, leaveType) => {
//     handleLeaveTypeChange(recordId, leaveType);
//     setLeaveMenuId(null);
//     setLeaveMenuPos(null);
//   };

//   // Opens/closes the leave-type dropdown for a row and computes a
//   // viewport-fixed position for it (used by the portal below). This is
//   // what keeps the dropdown from being clipped by the scrolling table:
//   // it's positioned relative to the *viewport*, not the row/table.
//   const handleToggleLeaveMenu = (e, recordId) => {
//     e.stopPropagation();
//     const opening = leaveMenuId !== recordId;

//     if (!opening) {
//       setLeaveMenuId(null);
//       setLeaveMenuPos(null);
//       return;
//     }

//     const rect = e.currentTarget.getBoundingClientRect();
//     const estimatedHeight =
//       leaveTypes.length * LEAVE_DROPDOWN_ITEM_HEIGHT +
//       LEAVE_DROPDOWN_EXTRA_HEIGHT;
//     const spaceBelow = window.innerHeight - rect.bottom;
//     const openUpward =
//       spaceBelow < estimatedHeight && rect.top > estimatedHeight;

//     const left = Math.min(
//       Math.max(8, rect.right - LEAVE_DROPDOWN_WIDTH),
//       window.innerWidth - LEAVE_DROPDOWN_WIDTH - 8,
//     );

//     setLeaveMenuPos({
//       left,
//       top: openUpward ? rect.top - estimatedHeight - 6 : rect.bottom + 6,
//     });
//     setLeaveMenuId(recordId);
//   };

//   // --- Manage Leave Types modal handlers ---
//   const handleAddLeaveType = () => {
//     const trimmed = newLeaveTypeInput.trim();
//     if (!trimmed) return;
//     const exists = leaveTypes.some(
//       (lt) => lt.toLowerCase() === trimmed.toLowerCase(),
//     );
//     if (exists) {
//       setNewLeaveTypeInput("");
//       return;
//     }
//     setLeaveTypes((prev) => [...prev, trimmed]);
//     setNewLeaveTypeInput("");
//   };

//   const handleDeleteLeaveType = (leaveType) => {
//     setLeaveTypes((prev) => prev.filter((lt) => lt !== leaveType));
//     // Clear that leave type off any rows currently using it so nothing
//     // points at a leave type that no longer exists.
//     setRecords((prev) =>
//       prev.map((r) =>
//         r.leaveType === leaveType ? { ...r, leaveType: null } : r,
//       ),
//     );
//   };

//   // Ignores clicks that started on the status buttons, leave dropdown, or
//   // the action menu, since those already have their own click behavior.
//   const handleRowClick = (e, record) => {
//     if (
//       e.target.closest(`.${styles.statusButtons}`) ||
//       e.target.closest(`.${styles.actionCell}`)
//     ) {
//       return;
//     }
//     setDetailEmployeeId(record.employee.id);
//   };

//   // Called from inside StaffDetailModal when a calendar day is edited.
//   const handleUpdateStatus = (employeeId, date, status) => {
//     setRecords((prev) => updateRecordStatus(prev, employeeId, date, status));
//     setHistory((prev) => [
//       ...prev,
//       {
//         id: `${employeeId}-${date}-${Date.now()}`,
//         employeeId,
//         timestamp: new Date().toISOString(),
//         type: "attendance",
//         description: status
//           ? `Marked ${formatDate(date)} as ${status}`
//           : `Cleared attendance for ${formatDate(date)}`,
//       },
//     ]);
//   };

//   // Called from inside StaffDetailModal when gross salary is edited.
//   const handleUpdateSalary = (employeeId, monthlySalary) => {
//     setEmployees((prev) =>
//       updateEmployeeSalary(prev, employeeId, monthlySalary),
//     );
//     setHistory((prev) => [
//       ...prev,
//       {
//         id: `${employeeId}-salary-${Date.now()}`,
//         employeeId,
//         timestamp: new Date().toISOString(),
//         type: "salary",
//         description: `Gross salary updated to ₹${monthlySalary.toLocaleString("en-IN")}`,
//       },
//     ]);
//   };

//   const gridColumns = "0.5fr 1fr 1.4fr 1.2fr 1.5fr 1.8fr";

//   // The record whose leave dropdown is currently open (looked up once for
//   // the portal render below, instead of doing it inline in JSX).
//   const activeLeaveRecord =
//     leaveMenuId != null
//       ? filteredRecords.find((r) => r.id === leaveMenuId)
//       : null;

//   return (
//     <div
//       className={styles.attendance}
//       style={mode ? { background: "#2C2E33", border: "none" } : {}}
//     >
//       <div className={styles.attendance_body}>
//         <div
//           className={styles.attendance_filters_wrapper}
//           style={mode ? { background: "#232529" } : {}}
//         >
//           <HrmFilters
//             mode={mode}
//             headerData={statusCards}
//             selectedFilter={selectedFilter}
//             handleClick={setSelectedFilter}
//             type="attendance"
//           />
//         </div>
//       </div>

//       <div className={styles.attendance_data}>
//         <div className={styles.attendance_data_filters}>
//           <SearchBar
//             placeholder="Search Employee..."
//             value={keyword}
//             padding="5px 10px"
//             onChange={(e) => setKeyword(e.target.value)}
//             onClear={() => setKeyword("")}
//           />

//           <div>
//             {selectedDate !== TODAY && (
//               <button
//                 type="button"
//                 className={styles.clearDateBtn}
//                 onClick={() => setSelectedDate(TODAY)}
//               >
//                 Back to today
//               </button>
//             )}

//             <div className={styles.period}>
//               <InputTypedate
//                 text={"Date"}
//                 value={selectedDate}
//                 onChange={(e) => setSelectedDate(e.target.value)}
//               />
//             </div>

//             <button
//               type="button"
//               className={styles.sortOrderBtn}
//               onClick={() =>
//                 setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
//               }
//               title={
//                 sortOrder === "asc"
//                   ? "Sorted A to Z — click for Z to A"
//                   : "Sorted Z to A — click for A to Z"
//               }
//             >
//               {sortOrder === "asc" ? <SortAscIcon /> : <SortDescIcon />}
//               <span>{sortOrder === "asc" ? "Ascending" : "Descending"}</span>
//             </button>

//             <DropDown
//               label={"Designation"}
//               listLabel={"All"}
//               options={role}
//               onSelect={(option) => setRole(option.value)}
//               onReject={() => setRole(null)}
//             />
//           </div>
//         </div>

//         <ul className={styles.attendanceTable} ref={tableRef}>
//           <li
//             className={styles.attendanceTableHeader}
//             style={{
//               gridTemplateColumns: gridColumns,
//               background: mode ? "#232529" : "#d9dce5",
//               color: mode ? "#fff" : "#646b88",
//             }}
//           >
//             <div>S.No.</div>
//             <div>Staff Id</div>
//             <div>Staff</div>
//             <div>Designation</div>
//             <div>Shift</div>
//             {/* <div>Date</div> */}
//             <div>Status</div>
//             {/* <div>Action</div> */}
//           </li>

//           {filteredRecords.length === 0 && (
//             <li className={styles.attendanceEmptyRow}>
//               No attendance found for {formatDate(selectedDate)}.
//             </li>
//           )}

//           {filteredRecords.map((record, index) => (
//             <li
//               key={record.id}
//               className={`${styles.attendanceTableRow} ${mode ? styles.attendanceTableRowDark : ""}`}
//               style={{ gridTemplateColumns: gridColumns, ...getRowStyle() }}
//               onClick={(e) => handleRowClick(e, record)}
//               title="Click to view staff attendance & salary slip"
//             >
//               <div>{index + 1}</div>
//               <div>{record.employee.staffId}</div>
//               <div>{record.employee.name}</div>
//               <div>{record.employee.department}</div>
//               <div>{record.employee.shift}</div>
//               {/* <div>{formatDate(record.date)}</div> */}

//               <div className={styles.statusButtons}>
//                 {ROW_STATUS_OPTIONS.map((option) => {
//                   const color = STATUS_COLORS[option];
//                   const isActive = record.status === option;
//                   return (
//                     <button
//                       key={option}
//                       type="button"
//                       onClick={() => handleStatusChange(record.id, option)}
//                       className={styles.statusButton}
//                       style={{
//                         borderColor: isActive
//                           ? color.border
//                           : mode
//                             ? "#ffffff"
//                             : "#000000",
//                         background: isActive ? color.border : "transparent",
//                         color: isActive
//                           ? "#ffffff"
//                           : mode
//                             ? "#ffffff"
//                             : "#000000",
//                       }}
//                     >
//                       {option}
//                     </button>
//                   );
//                 })}

//                 {/* Active leave-type tag, if one is set on this row */}
//                 {record.leaveType && (
//                   <span
//                     className={styles.leaveTag}
//                     style={{
//                       borderColor: LEAVE_TAG_COLOR,
//                       color: LEAVE_TAG_COLOR,
//                     }}
//                   >
//                     {record.leaveType}
//                     <button
//                       type="button"
//                       className={styles.leaveTagClear}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleLeaveTypeChange(record.id, null);
//                       }}
//                       aria-label="Clear leave type"
//                     >
//                       &times;
//                     </button>
//                   </span>
//                 )}

//                 <div className={styles.leaveDropdownWrapper}>
//                   <button
//                     type="button"
//                     className={`${styles.leaveChevronBtn} ${record.leaveType ? styles.leaveChevronBtnActive : ""}`}
//                     style={{
//                       borderColor: record.leaveType
//                         ? LEAVE_TAG_COLOR
//                         : mode
//                           ? "#ffffff"
//                           : "#000000",
//                       color: record.leaveType
//                         ? LEAVE_TAG_COLOR
//                         : mode
//                           ? "#ffffff"
//                           : "#000000",
//                     }}
//                     onClick={(e) => handleToggleLeaveMenu(e, record.id)}
//                     title="Set leave type"
//                   >
//                     <ChevronDownIcon />
//                   </button>
//                 </div>
//               </div>

//               {/* <div className={styles.actionCell}>
//                 <button
//                   type="button"
//                   className={styles.actionDotsBtn}
//                   onClick={() =>
//                     setOpenMenuId(openMenuId === record.id ? null : record.id)
//                   }
//                   aria-label="Row actions"
//                 >
//                   &#8942;
//                 </button>

//                 {openMenuId === record.id && (
//                   <div
//                     ref={menuRef}
//                     className={`${styles.actionDropdown} ${mode ? styles.actionDropdownDark : ""}`}
//                   >
//                     <button
//                       type="button"
//                       className={styles.actionDropdownItem}
//                       onClick={() => handleView(record)}
//                     >
//                       <span className={styles.actionDropdownIcon}>
//                         <EyeIcon />
//                       </span>
//                       <span>View</span>
//                     </button>
//                     <button
//                       type="button"
//                       className={`${styles.actionDropdownItem} ${styles.actionDropdownItemDanger}`}
//                       onClick={() => handleDelete(record.id)}
//                     >
//                       <span className={styles.actionDropdownIcon}>
//                         <TrashIcon />
//                       </span>
//                       <span>Delete</span>
//                     </button>
//                   </div>
//                 )}
//               </div> */}
//             </li>
//           ))}
//         </ul>
//       </div>

//       {activeLeaveRecord &&
//         leaveMenuPos &&
//         createPortal(
//           <div
//             className={`${styles.leaveDropdown} ${mode ? styles.leaveDropdownDark : ""}`}
//             style={{
//               position: "fixed",
//               top: leaveMenuPos.top,
//               left: leaveMenuPos.left,
//               width: LEAVE_DROPDOWN_WIDTH,
//               margin: 0,
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {leaveTypes.length === 0 && (
//               <div className={styles.leaveDropdownEmpty}>
//                 No leave types yet
//               </div>
//             )}
//             {leaveTypes.map((lt) => (
//               <button
//                 key={lt}
//                 type="button"
//                 style={{
//                   color:
//                     activeLeaveRecord.leaveType === lt
//                       ? "#8B5CF6"
//                       : mode
//                         ? "#ffffff"
//                         : "#000000",
//                 }}
//                 className={`${styles.leaveDropdownItem} ${
//                   activeLeaveRecord.leaveType === lt
//                     ? styles.leaveDropdownItemActive
//                     : ""
//                 }`}
//                 onClick={() => handleSelectLeaveType(activeLeaveRecord.id, lt)}
//               >
//                 {lt}
//               </button>
//             ))}
//             <div className={styles.leaveDropdownDivider} />
//             <button
//               type="button"
//               className={styles.leaveDropdownManageBtn}
//               onClick={() => {
//                 setShowLeaveManager(true);
//                 setLeaveMenuId(null);
//                 setLeaveMenuPos(null);
//               }}
//             >
//               <PlusIcon />
//               <span>Manage leave types</span>
//             </button>
//           </div>,
//           document.body,
//         )}

//       {viewRecord && (
//         <div
//           className={styles.modalOverlay}
//           onClick={() => setViewRecord(null)}
//         >
//           <div
//             className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className={styles.modalCloseBtn}
//               onClick={() => setViewRecord(null)}
//             >
//               &times;
//             </button>
//             <h3>{viewRecord.employee.name}</h3>
//             <p>
//               <strong>Staff ID:</strong> {viewRecord.employee.staffId}
//             </p>
//             <p>
//               <strong>Designation:</strong> {viewRecord.employee.department}
//             </p>
//             <p>
//               <strong>Shift:</strong> {viewRecord.employee.shift}
//             </p>
//             <p>
//               <strong>Date:</strong> {formatDate(viewRecord.date)}
//             </p>
//             <p>
//               <strong>Status:</strong>{" "}
//               <span
//                 style={{
//                   color: STATUS_COLORS[viewRecord.status]?.border,
//                   fontWeight: 600,
//                 }}
//               >
//                 {viewRecord.status}
//               </span>
//             </p>
//           </div>
//         </div>
//       )}

//       {/* Manage Leave Types modal — add new leave categories or remove old ones */}
//       {showLeaveManager && (
//         <div
//           className={styles.modalOverlay}
//           onClick={() => setShowLeaveManager(false)}
//         >
//           <div
//             className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className={styles.modalCloseBtn}
//               onClick={() => setShowLeaveManager(false)}
//             >
//               &times;
//             </button>
//             <h6>Manage Leave Types</h6>

//             <div className={styles.leaveManagerList}>
//               {leaveTypes.length === 0 && (
//                 <div className={styles.leaveManagerEmpty}>
//                   No leave types yet. Add one below.
//                 </div>
//               )}
//               {leaveTypes.map((lt) => (
//                 <div key={lt} className={styles.leaveManagerItem}>
//                   <span>{lt}</span>
//                   <button
//                     type="button"
//                     className={styles.leaveManagerDeleteBtn}
//                     onClick={() => handleDeleteLeaveType(lt)}
//                     aria-label={`Delete ${lt}`}
//                     title={`Delete ${lt}`}
//                   >
//                     <TrashIcon />
//                   </button>
//                 </div>
//               ))}
//             </div>

//             <div className={styles.leaveManagerAddRow}>
//               <input
//                 type="text"
//                 className={styles.leaveManagerInput}
//                 placeholder="Add new leave type..."
//                 value={newLeaveTypeInput}
//                 onChange={(e) => setNewLeaveTypeInput(e.target.value)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") {
//                     e.preventDefault();
//                     handleAddLeaveType();
//                   }
//                 }}
//               />
//               <button
//                 type="button"
//                 className={styles.leaveManagerAddBtn}
//                 onClick={handleAddLeaveType}
//                 disabled={!newLeaveTypeInput.trim()}
//               >
//                 Add
//               </button>
//             </div>

//             <button
//               type="button"
//               className={styles.leaveManagerDoneBtn}
//               onClick={() => setShowLeaveManager(false)}
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {detailEmployee && (
//         <StaffDetailModal
//           employee={detailEmployee}
//           records={records}
//           history={history}
//           mode={mode}
//           onClose={() => setDetailEmployeeId(null)}
//           onUpdateStatus={handleUpdateStatus}
//           onUpdateSalary={handleUpdateSalary}
//         />
//       )}
//     </div>
//   );
// };

// export default Attendance;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./Attendance.module.css";
import { useAuth } from "../../components/context/Auth";
import HrmFilters from "../../components/updatedComponents/hrm/HrmFillters";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import StaffDetailModal from "./EmployeeDetailModal";
import {
  STATUS_OPTIONS,
  STATUS_COLORS,
  TODAY,
  EMPLOYEES,
  buildInitialRecords,
  updateRecordStatus,
  updateEmployeeSalary,
  formatDate,
  AllDesignation,
} from "./HrmData";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";

const SortAscIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 5v14" />
    <path d="M5 11l6-6 6 6" />
  </svg>
);

const SortDescIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 19V5" />
    <path d="M5 13l6 6 6-6" />
  </svg>
);

// Small chevron used to open the "pick a leave type" dropdown on a row
const ChevronDownIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const PlusIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const TrashIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
  </svg>
);

const DEFAULT_LEAVE_TYPES = [
  "Paid Leave",
  "Sick Leave",
  "Casual Leave",
  "Unpaid Leave",
];
const LEAVE_TAG_COLOR = "#8B5CF6";

const ROW_STATUS_OPTIONS = STATUS_OPTIONS.filter(
  (option) => option !== "Leave",
);

// Width/height estimates used only to decide whether the portal-rendered
// dropdown should open upward or downward, and to keep it inside the
// viewport horizontally. Kept in one place so they're easy to tweak.
const LEAVE_DROPDOWN_WIDTH = 200;
const LEAVE_DROPDOWN_ITEM_HEIGHT = 36;
const LEAVE_DROPDOWN_EXTRA_HEIGHT = 60; // divider + manage button + padding

const Attendance = () => {
  const { mode } = useAuth();
  const [role, setRole] = useState([]);
  useEffect(() => {
    if (AllDesignation) {
      setRole(
        AllDesignation.map((r) => ({
          label: r.name,
          value: r.name,
        })),
      );
    }
  }, []);
  const [employees, setEmployees] = useState(EMPLOYEES); // holds salary edits made in StaffDetailModal
  const [records, setRecords] = useState(buildInitialRecords); // holds attendance edits made in StaffDetailModal
  const [history, setHistory] = useState([]); // audit log of edits, shown in StaffDetailModal's History tab
  const [keyword, setKeyword] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [selectedDate, setSelectedDate] = useState(TODAY);
  const [sortOrder, setSortOrder] = useState("asc");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [viewRecord, setViewRecord] = useState(null);
  const [detailEmployeeId, setDetailEmployeeId] = useState(null); // id shown in StaffDetailModal
  const menuRef = useRef(null);
  const tableRef = useRef(null); // scroll container for the attendance list

  // --- Leave-type dropdown + manager state ---
  const [leaveTypes, setLeaveTypes] = useState(DEFAULT_LEAVE_TYPES);
  const [leaveMenuId, setLeaveMenuId] = useState(null); // record id whose leave dropdown is open
  // Fixed viewport position for the portal-rendered leave dropdown.
  // Computed from the trigger button's bounding rect so the dropdown is
  // never clipped by the scrolling table container (see onClick below).
  const [leaveMenuPos, setLeaveMenuPos] = useState(null); // {top, left}
  const [showLeaveManager, setShowLeaveManager] = useState(false);
  const [newLeaveTypeInput, setNewLeaveTypeInput] = useState("");

  const employeeMap = useMemo(
    () => Object.fromEntries(employees.map((e) => [e.id, e])),
    [employees],
  );
  const detailEmployee =
    detailEmployeeId != null ? employeeMap[detailEmployeeId] : null;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
      // The leave dropdown now renders in a portal attached to
      // document.body, so it's no longer a DOM descendant of the row.
      // We close it based on whether the click landed on the trigger
      // wrapper or on the portal dropdown itself.
      if (
        leaveMenuId !== null &&
        !e.target.closest(`.${styles.leaveDropdownWrapper}`) &&
        !e.target.closest(`.${styles.leaveDropdown}`)
      ) {
        setLeaveMenuId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [leaveMenuId]);

  // Close the leave dropdown if the table scrolls, so it doesn't end up
  // floating in the wrong spot relative to the row that opened it.
  useEffect(() => {
    const tableEl = tableRef.current;
    if (!tableEl) return;
    const handleScroll = () => {
      setLeaveMenuId(null);
      setLeaveMenuPos(null);
    };
    tableEl.addEventListener("scroll", handleScroll);
    return () => tableEl.removeEventListener("scroll", handleScroll);
  }, []);

  // Also reposition/close on window resize to avoid a stale fixed position.
  useEffect(() => {
    if (leaveMenuId === null) return;
    const handleResize = () => {
      setLeaveMenuId(null);
      setLeaveMenuPos(null);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [leaveMenuId]);

  const recordsForSelectedDate = useMemo(() => {
    return records
      .filter((r) => r.date === selectedDate)
      .map((r) => ({ ...r, employee: employeeMap[r.employeeId] }))
      .filter((r) => r.employee);
  }, [records, selectedDate, employeeMap]);

  const statusCards = useMemo(() => {
    const counts = { All: recordsForSelectedDate.length };
    STATUS_OPTIONS.forEach((s) => (counts[s] = 0));
    recordsForSelectedDate.forEach((r) => {
      counts[r.status] = (counts[r.status] || 0) + 1;
    });

    return [
      { status: "All", count: counts.All, subtitle: "All employees" },
      { status: "Present", count: counts.Present, subtitle: "Marked present" },
      { status: "Absent", count: counts.Absent, subtitle: "Marked absent" },
      {
        status: "Half-Day",
        count: counts["Half-Day"],
        subtitle: "Half day rows",
      },
      { status: "Leave", count: counts["Leave"], subtitle: "Marked Leave" },
    ];
  }, [recordsForSelectedDate]);

  const getRowStyle = () => ({ background: mode ? "#1B1D21" : "#FFFFFF" });

  const filteredRecords = useMemo(() => {
    const result = recordsForSelectedDate.filter((r) => {
      const search =
        r.employee.name.toLowerCase().includes(keyword.toLowerCase()) ||
        r.employee.department.toLowerCase().includes(keyword.toLowerCase()) ||
        r.employee.staffId.toLowerCase().includes(keyword.toLowerCase());

      const filter =
        selectedFilter === "All" ? true : r.status === selectedFilter;
      return search && filter;
    });

    result.sort((a, b) => {
      const diff = a.employee.name.localeCompare(b.employee.name);
      return sortOrder === "asc" ? diff : -diff;
    });

    return result;
  }, [recordsForSelectedDate, keyword, selectedFilter, sortOrder]);

  const handleStatusChange = (recordId, newStatus) => {
    setRecords((prev) =>
      prev.map((r) => (r.id === recordId ? { ...r, status: newStatus } : r)),
    );
  };

  const handleDelete = (recordId) => {
    setRecords((prev) => prev.filter((r) => r.id !== recordId));
    setOpenMenuId(null);
  };

  const handleView = (record) => {
    setViewRecord(record);
    setOpenMenuId(null);
  };

  // Sets (or clears, if leaveType is null) the leave type on a row. Kept
  // separate from `status` so a row can carry "Half-Day" + "Sick Leave"
  // together if that's ever useful, without the two fields fighting.
  const handleLeaveTypeChange = (recordId, leaveType) => {
    setRecords((prev) =>
      prev.map((r) => (r.id === recordId ? { ...r, leaveType } : r)),
    );
    setHistory((prev) => [
      ...prev,
      {
        id: `${recordId}-leave-${Date.now()}`,
        recordId,
        timestamp: new Date().toISOString(),
        type: "leave",
        description: leaveType
          ? `Marked leave type as ${leaveType}`
          : "Cleared leave type",
      },
    ]);
  };

  const handleSelectLeaveType = (recordId, leaveType) => {
    handleLeaveTypeChange(recordId, leaveType);
    setLeaveMenuId(null);
    setLeaveMenuPos(null);
  };

  // Opens/closes the leave-type dropdown for a row and computes a
  // viewport-fixed position for it (used by the portal below). This is
  // what keeps the dropdown from being clipped by the scrolling table:
  // it's positioned relative to the *viewport*, not the row/table.
  const handleToggleLeaveMenu = (e, recordId) => {
    e.stopPropagation();
    const opening = leaveMenuId !== recordId;

    if (!opening) {
      setLeaveMenuId(null);
      setLeaveMenuPos(null);
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const estimatedHeight =
      leaveTypes.length * LEAVE_DROPDOWN_ITEM_HEIGHT +
      LEAVE_DROPDOWN_EXTRA_HEIGHT;
    const spaceBelow = window.innerHeight - rect.bottom;
    const openUpward =
      spaceBelow < estimatedHeight && rect.top > estimatedHeight;

    const left = Math.min(
      Math.max(8, rect.right - LEAVE_DROPDOWN_WIDTH),
      window.innerWidth - LEAVE_DROPDOWN_WIDTH - 8,
    );

    setLeaveMenuPos({
      left,
      top: openUpward ? rect.top - estimatedHeight - 6 : rect.bottom + 6,
    });
    setLeaveMenuId(recordId);
  };

  // --- Manage Leave Types modal handlers ---
  const handleAddLeaveType = () => {
    const trimmed = newLeaveTypeInput.trim();
    if (!trimmed) return;
    const exists = leaveTypes.some(
      (lt) => lt.toLowerCase() === trimmed.toLowerCase(),
    );
    if (exists) {
      setNewLeaveTypeInput("");
      return;
    }
    setLeaveTypes((prev) => [...prev, trimmed]);
    setNewLeaveTypeInput("");
  };

  const handleDeleteLeaveType = (leaveType) => {
    setLeaveTypes((prev) => prev.filter((lt) => lt !== leaveType));
    // Clear that leave type off any rows currently using it so nothing
    // points at a leave type that no longer exists.
    setRecords((prev) =>
      prev.map((r) =>
        r.leaveType === leaveType ? { ...r, leaveType: null } : r,
      ),
    );
  };

  // Ignores clicks that started on the status buttons, leave dropdown, or
  // the action menu, since those already have their own click behavior.
  const handleRowClick = (e, record) => {
    if (
      e.target.closest(`.${CSS.escape(styles.statusButtons)}`) ||
      e.target.closest(`.${CSS.escape(styles.actionCell)}`)
    ) {
      return;
    }
    setDetailEmployeeId(record.employee.id);
  };

  // Called from inside StaffDetailModal when a calendar day is edited.
  // `leaveType` (optional) tags which leave category applies when status is
  // "Leave" — it's always kept in sync with status: cleared whenever the
  // status isn't "Leave", so a day never carries a stale leave type.
  const handleUpdateStatus = (employeeId, date, status, leaveType = null) => {
    setRecords((prev) => {
      const next = updateRecordStatus(prev, employeeId, date, status);
      return next.map((r) =>
        r.employeeId === employeeId && r.date === date
          ? { ...r, leaveType: status === "Leave" ? leaveType : null }
          : r,
      );
    });
    setHistory((prev) => [
      ...prev,
      {
        id: `${employeeId}-${date}-${Date.now()}`,
        employeeId,
        timestamp: new Date().toISOString(),
        type: "attendance",
        description: status
          ? `Marked ${formatDate(date)} as ${status}${
              status === "Leave" && leaveType ? ` (${leaveType})` : ""
            }`
          : `Cleared attendance for ${formatDate(date)}`,
      },
    ]);
  };

  // Called from inside StaffDetailModal when gross salary is edited.
  const handleUpdateSalary = (employeeId, monthlySalary) => {
    setEmployees((prev) =>
      updateEmployeeSalary(prev, employeeId, monthlySalary),
    );
    setHistory((prev) => [
      ...prev,
      {
        id: `${employeeId}-salary-${Date.now()}`,
        employeeId,
        timestamp: new Date().toISOString(),
        type: "salary",
        description: `Gross salary updated to ₹${monthlySalary.toLocaleString("en-IN")}`,
      },
    ]);
  };

  const gridColumns = "0.5fr 1fr 1.4fr 1.2fr 1.5fr 1.8fr";

  // The record whose leave dropdown is currently open (looked up once for
  // the portal render below, instead of doing it inline in JSX).
  const activeLeaveRecord =
    leaveMenuId != null
      ? filteredRecords.find((r) => r.id === leaveMenuId)
      : null;

  return (
    <div
      className={styles.attendance}
      style={mode ? { background: "#2C2E33", border: "none" } : {}}
    >
      <div className={styles.attendance_body}>
        <div
          className={styles.attendance_filters_wrapper}
          style={mode ? { background: "#232529" } : {}}
        >
          <HrmFilters
            mode={mode}
            headerData={statusCards}
            selectedFilter={selectedFilter}
            handleClick={setSelectedFilter}
            type="attendance"
          />
        </div>
      </div>

      <div className={styles.attendance_data}>
        <div className={styles.attendance_data_filters}>
          <SearchBar
            placeholder="Search Employee..."
            value={keyword}
            padding="5px 10px"
            onChange={(e) => setKeyword(e.target.value)}
            onClear={() => setKeyword("")}
          />

          <div>
            {selectedDate !== TODAY && (
              <button
                type="button"
                className={styles.clearDateBtn}
                onClick={() => setSelectedDate(TODAY)}
              >
                Back to today
              </button>
            )}

            <div className={styles.period}>
              <InputTypedate
                text={"Date"}
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>

            <button
              type="button"
              className={styles.sortOrderBtn}
              onClick={() =>
                setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
              }
              title={
                sortOrder === "asc"
                  ? "Sorted A to Z — click for Z to A"
                  : "Sorted Z to A — click for A to Z"
              }
            >
              {sortOrder === "asc" ? <SortAscIcon /> : <SortDescIcon />}
              <span>{sortOrder === "asc" ? "Ascending" : "Descending"}</span>
            </button>

            <DropDown
              label={"Designation"}
              listLabel={"All"}
              options={role}
              onSelect={(option) => setRole(option.value)}
              onReject={() => setRole(null)}
            />
          </div>
        </div>

        <ul className={styles.attendanceTable} ref={tableRef}>
          <li
            className={styles.attendanceTableHeader}
            style={{
              gridTemplateColumns: gridColumns,
              background: mode ? "#232529" : "#d9dce5",
              color: mode ? "#fff" : "#646b88",
            }}
          >
            <div>S.No.</div>
            <div>Staff Id</div>
            <div>Staff</div>
            <div>Designation</div>
            <div>Shift</div>
            {/* <div>Date</div> */}
            <div>Status</div>
            {/* <div>Action</div> */}
          </li>

          {filteredRecords.length === 0 && (
            <li className={styles.attendanceEmptyRow}>
              No attendance found for {formatDate(selectedDate)}.
            </li>
          )}

          {filteredRecords.map((record, index) => (
            <li
              key={record.id}
              className={`${styles.attendanceTableRow} ${mode ? styles.attendanceTableRowDark : ""}`}
              style={{ gridTemplateColumns: gridColumns, ...getRowStyle() }}
              onClick={(e) => handleRowClick(e, record)}
              title="Click to view staff attendance & salary slip"
            >
              <div>{index + 1}</div>
              <div>{record.employee.staffId}</div>
              <div>{record.employee.name}</div>
              <div>{record.employee.department}</div>
              <div>{record.employee.shift}</div>
              {/* <div>{formatDate(record.date)}</div> */}

              <div className={styles.statusButtons}>
                {ROW_STATUS_OPTIONS.map((option) => {
                  const color = STATUS_COLORS[option];
                  const isActive = record.status === option;
                  return (
                    <button
                      key={option}
                      type="button"
                      onClick={() => handleStatusChange(record.id, option)}
                      className={styles.statusButton}
                      style={{
                        borderColor: isActive
                          ? color.border
                          : mode
                            ? "#ffffff"
                            : "#000000",
                        background: isActive ? color.border : "transparent",
                        color: isActive
                          ? "#ffffff"
                          : mode
                            ? "#ffffff"
                            : "#000000",
                      }}
                    >
                      {option}
                    </button>
                  );
                })}

                {/* Active leave-type tag, if one is set on this row */}
                {record.leaveType && (
                  <span
                    className={styles.leaveTag}
                    style={{
                      borderColor: LEAVE_TAG_COLOR,
                      color: LEAVE_TAG_COLOR,
                    }}
                  >
                    {record.leaveType}
                    <button
                      type="button"
                      className={styles.leaveTagClear}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLeaveTypeChange(record.id, null);
                      }}
                      aria-label="Clear leave type"
                    >
                      &times;
                    </button>
                  </span>
                )}

                {/* Chevron opens the leave-type picker for this row. The
                    dropdown itself is rendered in a portal (see bottom of
                    this component) so it can never be clipped by the
                    scrolling table container. */}
                <div className={styles.leaveDropdownWrapper}>
                  <button
                    type="button"
                    className={`${styles.leaveChevronBtn} ${record.leaveType ? styles.leaveChevronBtnActive : ""}`}
                    style={{
                      borderColor: record.leaveType
                        ? LEAVE_TAG_COLOR
                        : mode
                          ? "#ffffff"
                          : "#000000",
                      color: record.leaveType
                        ? LEAVE_TAG_COLOR
                        : mode
                          ? "#ffffff"
                          : "#000000",
                    }}
                    onClick={(e) => handleToggleLeaveMenu(e, record.id)}
                    title="Set leave type"
                  >
                    <ChevronDownIcon />
                  </button>
                </div>
              </div>

              {/* <div className={styles.actionCell}>
                <button
                  type="button"
                  className={styles.actionDotsBtn}
                  onClick={() =>
                    setOpenMenuId(openMenuId === record.id ? null : record.id)
                  }
                  aria-label="Row actions"
                >
                  &#8942;
                </button>

                {openMenuId === record.id && (
                  <div
                    ref={menuRef}
                    className={`${styles.actionDropdown} ${mode ? styles.actionDropdownDark : ""}`}
                  >
                    <button
                      type="button"
                      className={styles.actionDropdownItem}
                      onClick={() => handleView(record)}
                    >
                      <span className={styles.actionDropdownIcon}>
                        <EyeIcon />
                      </span>
                      <span>View</span>
                    </button>
                    <button
                      type="button"
                      className={`${styles.actionDropdownItem} ${styles.actionDropdownItemDanger}`}
                      onClick={() => handleDelete(record.id)}
                    >
                      <span className={styles.actionDropdownIcon}>
                        <TrashIcon />
                      </span>
                      <span>Delete</span>
                    </button>
                  </div>
                )}
              </div> */}
            </li>
          ))}
        </ul>
      </div>

      {activeLeaveRecord &&
        leaveMenuPos &&
        createPortal(
          <div
            className={`${styles.leaveDropdown} ${mode ? styles.leaveDropdownDark : ""}`}
            style={{
              position: "fixed",
              top: leaveMenuPos.top,
              left: leaveMenuPos.left,
              width: LEAVE_DROPDOWN_WIDTH,
              margin: 0,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {leaveTypes.length === 0 && (
              <div className={styles.leaveDropdownEmpty}>
                No leave types yet
              </div>
            )}
            {leaveTypes.map((lt) => (
              <button
                key={lt}
                type="button"
                style={{
                  color:
                    activeLeaveRecord.leaveType === lt
                      ? "#8B5CF6"
                      : mode
                        ? "#ffffff"
                        : "#000000",
                }}
                className={`${styles.leaveDropdownItem} ${
                  activeLeaveRecord.leaveType === lt
                    ? styles.leaveDropdownItemActive
                    : ""
                }`}
                onClick={() => handleSelectLeaveType(activeLeaveRecord.id, lt)}
              >
                {lt}
              </button>
            ))}
            <div className={styles.leaveDropdownDivider} />
            <button
              type="button"
              className={styles.leaveDropdownManageBtn}
              onClick={() => {
                setShowLeaveManager(true);
                setLeaveMenuId(null);
                setLeaveMenuPos(null);
              }}
            >
              <PlusIcon />
              <span>Manage leave types</span>
            </button>
          </div>,
          document.body,
        )}

      {viewRecord && (
        <div
          className={styles.modalOverlay}
          onClick={() => setViewRecord(null)}
        >
          <div
            className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className={styles.modalCloseBtn}
              onClick={() => setViewRecord(null)}
            >
              &times;
            </button>
            <h3>{viewRecord.employee.name}</h3>
            <p>
              <strong>Staff ID:</strong> {viewRecord.employee.staffId}
            </p>
            <p>
              <strong>Designation:</strong> {viewRecord.employee.department}
            </p>
            <p>
              <strong>Shift:</strong> {viewRecord.employee.shift}
            </p>
            <p>
              <strong>Date:</strong> {formatDate(viewRecord.date)}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              <span
                style={{
                  color: STATUS_COLORS[viewRecord.status]?.border,
                  fontWeight: 600,
                }}
              >
                {viewRecord.status}
              </span>
            </p>
          </div>
        </div>
      )}

      {/* Manage Leave Types modal — add new leave categories or remove old ones */}
      {showLeaveManager && (
        <div
          className={styles.modalOverlay}
          onClick={() => setShowLeaveManager(false)}
        >
          <div
            className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className={styles.modalCloseBtn}
              onClick={() => setShowLeaveManager(false)}
            >
              &times;
            </button>
            <h6>Manage Leave Types</h6>

            <div className={styles.leaveManagerList}>
              {leaveTypes.length === 0 && (
                <div className={styles.leaveManagerEmpty}>
                  No leave types yet. Add one below.
                </div>
              )}
              {leaveTypes.map((lt) => (
                <div key={lt} className={styles.leaveManagerItem}>
                  <span>{lt}</span>
                  <button
                    type="button"
                    className={styles.leaveManagerDeleteBtn}
                    onClick={() => handleDeleteLeaveType(lt)}
                    aria-label={`Delete ${lt}`}
                    title={`Delete ${lt}`}
                  >
                    <TrashIcon />
                  </button>
                </div>
              ))}
            </div>

            <div className={styles.leaveManagerAddRow}>
              <input
                type="text"
                className={styles.leaveManagerInput}
                placeholder="Add new leave type..."
                value={newLeaveTypeInput}
                onChange={(e) => setNewLeaveTypeInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddLeaveType();
                  }
                }}
              />
              <button
                type="button"
                className={styles.leaveManagerAddBtn}
                onClick={handleAddLeaveType}
                disabled={!newLeaveTypeInput.trim()}
              >
                Add
              </button>
            </div>

            <button
              type="button"
              className={styles.leaveManagerDoneBtn}
              onClick={() => setShowLeaveManager(false)}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Single-staff Attendance calendar + Salary Slip, opened by clicking a row.
          Both the calendar days and the gross salary field are editable here. */}
      {detailEmployee && (
        <StaffDetailModal
          employee={detailEmployee}
          records={records}
          history={history}
          mode={mode}
          onClose={() => setDetailEmployeeId(null)}
          onUpdateStatus={handleUpdateStatus}
          onUpdateSalary={handleUpdateSalary}
          leaveTypes={leaveTypes}
        />
      )}
    </div>
  );
};

export default Attendance;
